import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import {
  getSettingValueSelector,
  makeEntityChildrenSelector,
  makeTextStyleSelector,
  TargetSelector
} from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const entityChildrenSelector = makeEntityChildrenSelector();
  const imageOrientationSelector = getSettingValueSelector(TargetSelector.Entity, "orientation", "image");
  const profileTypeSelector = getSettingValueSelector(TargetSelector.Entity, "profileType");
  const textStyleSelector = makeTextStyleSelector(TargetSelector.Entity);

  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props,
      imageOrientation: imageOrientationSelector(state, props),
      isEditMode: state.isEditMode,
      items: entityChildrenSelector(state, props),
      profileType: profileTypeSelector(state, props),
      textStyle: textStyleSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
